import * as React from 'react';
import { useDrop } from 'react-dnd';
import { FieldItem, ItemTypes, DragItemField } from '../types';

interface AggregateDropPanelComponentProps {
  className?: string;
  addItem: (item: FieldItem) => void;
  isOver?: any;
  canDrop?: any;
  children?: React.ReactNode;
  added?: boolean;
}
export const dropPanelForItemType = (itemType: ItemTypes) => {
  const AggregateDropPanelComponent: React.FC<AggregateDropPanelComponentProps> = (
    { className, children, addItem }
  ) => {
    const [{ isOver }, drop] = useDrop({
      accept: itemType,
      drop: (item: DragItemField) => {
        addItem(item.field); 
      },
      collect: (monitor) => ({
        isOver: monitor.isOver()
      })
    });
       
    return <div ref={(node) => {
      drop(node);
    }} className={`${className} ${isOver ? 'drag-active' : ''}`} >
        {children}
    </div>;    
  };

  return (AggregateDropPanelComponent);
};
